import _ from 'underscore';
import Backbone from 'backbone';
import VideoView from 'views/store/common/video';
import 'slick-carousel';
import SlickHelper from 'views/store/common/helpers/slick';
import TrackingHelper from 'views/store/tracking_helper';
import gtmHelper from 'lib/helpers/gtm_helper';

export default Backbone.View.extend({
	el: '.gallery',

	events: {
		'mouseenter .js-gallery-thumbnail': '_hoverGalleryThumbnail',
		'click .js-gallery-thumbnail': '_selectGalleryThumbnail',
		'click .js-gallery-big-thumb': '_selectCarouselImage',
		'click .gallery-image': 'launchMediaGalleryModal',
		'click .js-gallery-text': 'launchMediaGalleryModal',
		'click .js-zoom-in': 'launchMediaGalleryModal',
		'hidden.bs.modal .js-modal-media-gallery': '_modalClosed',
		'hide.bs.modal .js-modal-media-gallery': '_onModalHide'
	},

	initialize() {
		this.$modal = $('.js-modal-media-gallery');
		this.$mainMediaGallery = $('#product-images-container');
		this.defaultSlickConfig = {
			infinite: false,
			arrows: false,
			lazyLoad: 'ondemand',
			dots: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			responsive: [
				{ breakpoint: 992, settings: { slidesToShow: 1 } },
				{ breakpoint: 1200, settings: { slidesToShow: 1 } }
			]
		};
		this.currentIndex = window.dataLayer.defaultImageIndex;
		this.gallery = this.model.get('mediaGallery').filter(function(media) {
			return media.hasImage || media.hasOwnProperty('FINISH');
		});

		if (!this.gallery.length) {
			return;
		}

		this.listenTo(Backbone, 'finish:clicked', this._selectFinishThumbnail);
		this.listenTo(Backbone, 'finish:hover', this._selectFinishThumbnail);

		if (window.BCOM.device.isMobile) {
			this._updateSelected();
		}

		if (!window.BCOM.device.isDesktop) {
			this.$slider = this.$el.find('.js-img-swipe');
			this._initSlickSlider();
			// IDS-24419 let src/app/views/store/common/videos.js re-delegate events for each video view,
			// since recent slick-slider version 1.8.1 caused events to unbind from initial video views.
			Backbone.trigger('mediagallery:rebindEvents');
		}
	},
	_sliderBeforeChange(event, slick, currentSlide, nextSlide) {
		this.slideAnimating = true;
		if (this.$galleryThumbNail && this.$galleryThumbNail.length) {
			const $currentGalleryThumbNail = this.$galleryThumbNail.find(`.js-gallery-big-thumb[data-iterator=${nextSlide}]`);
			if ($currentGalleryThumbNail && $currentGalleryThumbNail.length) {
				const $thumbnailList = $('.thumbnails');
				// Scroll the selected image to the center
				const scrollAmt =
					$currentGalleryThumbNail.position().left -
					$(window).width() / 2 +
					$thumbnailList.scrollLeft() +
					$currentGalleryThumbNail.outerWidth() / 2;
				$thumbnailList.animate(
					{
						scrollLeft: scrollAmt
					},
					200,
					'linear'
				);
				$currentGalleryThumbNail.trigger('click');
			}
		}
	},
	_sliderAfterChange(event, slick, currentSlide) {
		this.currentIndex = currentSlide;
		const currentImg = $(slick.$slides[currentSlide]).find('img');
		const currentImgFinish = currentImg.data('finish');
		const imgType = currentImgFinish ? 'Finish' : 'Description';
		const imgDesc = currentImgFinish || currentImg.data('title');
		this._setModalTypeAndDescription(imgType, imgDesc);
		this.slideAnimating = false;
		this._updateSelected();
	},
	_sliderSwipe(event, slick, direction) {
		const $currentTarget = $(event.target);
		const trackId = $currentTarget.length ? $currentTarget.data('track-id') : 'media-gallery:swipe';
		if (trackId) {
			gtmHelper.fireEvent({
				event: 'generic-click-tracking',
				linkName: `${trackId}:swipe-${direction}`
			});

			Backbone.trigger('track:link', {
				linkName: `${trackId}:swipe-${direction}`
			});
		}
		this._pauseVideos();
	},

	_initSlickSlider(slickConfig) {
		slickConfig = slickConfig || {};
		const isSliderInitialized = Boolean(this.$slider.not('.slick-initialized').length === 0);
		if (this.$slider && this.$slider.length && !isSliderInitialized) {
			// these were moved out of thier arrow functions to reduce the complexity of this function.
			// they use a bind(this) to keep the function context on the backbone view
			this.$slider.on('afterChange', this._sliderAfterChange.bind(this));
			this.$slider.on('beforeChange', this._sliderBeforeChange.bind(this));
			this.$slider.on('swipe', this._sliderSwipe.bind(this));
			this.$slider.not('.slick-initialized').slick(Object.assign(this.defaultSlickConfig, slickConfig));
		}
		this.$slider.slick('slickGoTo', this.currentIndex);
		SlickHelper.addClassesToLi(this.$slider);
	},
	_findWithImage(galleryItem) {
		return Boolean(galleryItem.hasImage);
	},
	_setModalTypeAndDescription(type, description) {
		this.$el.find('.js-modal-media-gallery .js-img-type').html(type);
		this.$el.find('.js-modal-media-gallery .js-img-desc').html(description);
	},
	_initializeSlider(imageIndex, $slider, slickConfig) {
		this._initSlickSlider(slickConfig);
		$slider.slick('slickGoTo', imageIndex);
		this._initZoom();
		this._resizeGallery();
	},
	_renderCarouselThumbnails(error, out) {
		if (!error) {
			this.$('.js-media-gallery-modal-thumbnail').html(out);
			this.$slider = this.$modal.find('.js-img-modal-swipe');
			this.$galleryThumbNail = $('.js-media-gallery-modal-thumbnail');
			this._updateSelected();
			this.$modal.on(
				'shown.bs.modal',
				this._initializeSlider.bind(this, this.imageIndex, this.$slider, {
					dots: false
				})
			);
			this.$galleryModal = this.$modal.modal('show');
			$(window).trigger('resize', () => {
				this._resizeGallery();
			});
			TrackingHelper.injectActivityMap('.js-media-gallery-modal-thumbnail img').catch(window.clientErrorHandler);
		}
	},
	_renderCarousel([, , dustjs, templateModalCarousel, templateModalThumbnail]) {
		const filteredGallery = this.gallery.filter(this._findWithImage);
		dustjs.render(
			templateModalCarousel,
			{
				mediaGallery: filteredGallery
			},
			(error, out) => {
				if (!error) {
					this.$('.js-media-gallery-modal-carousel').html(out);
					this._initVideos();
					dustjs.render(
						templateModalThumbnail,
						{
							mediaGallery: filteredGallery
						},
						this._renderCarouselThumbnails.bind(this)
					);
				}
			}
		);
	},
	launchMediaGalleryModal(e) {
		if (e) {
			e.stopPropagation();
		}
		const filteredGallery = this.gallery.filter(this._findWithImage),
			galleryItem = this.gallery[this.currentIndex] || filteredGallery[0] || this.gallery[0];
		const type = galleryItem.FINISH ? 'Finish' : 'Description',
			desc = galleryItem.isVideo ? galleryItem.video.title : galleryItem.TITLE;
		if (this.$mainMediaGallery.hasClass('affix')) {
			this.$mainMediaGallery.removeClass('affix');
			this.wasAffixed = true;
		}
		// make sure the gallery opens to an image
		if (galleryItem.hasImage) {
			this.imageIndex = _(filteredGallery).indexOf(galleryItem);
		} else {
			const firstItemWithIndex = this.gallery.filter(this._findWithImage)[0];
			if (firstItemWithIndex) {
				this.imageIndex = _(filteredGallery).indexOf(firstItemWithIndex);
			} else {
				this.imageIndex = 0;
			}
		}
		this._setModalTypeAndDescription(type, desc);
		Backbone.trigger('omniture:clicktracking', 'media gallery:opened');
		if (this.$galleryModal) {
			this.$galleryModal.modal('show');
			this.$slider = this.$modal.find('.js-img-modal-swipe');
			this.$slider.slick('slickGoTo', this.imageIndex);
			return;
		}
		Promise.all([
			import('jquery.panzoom'),
			import('doubletap'),
			import('dustjs'),
			import('store/global/pages/products/_media_gallery_modal_carousel.dust'),
			import('store/global/pages/products/_media_gallery_modal_thumbnail.dust'),
			import('common/videos/_wistia.dust'),
			import('common/videos/_youtube.dust')
		])
			.then(this._renderCarousel.bind(this))
			.catch(window.clientErrorHandler);
	},
	_pauseVideos() {
		Backbone.trigger('videos:pause');
	},
	_initVideos() {
		if (!this.childViews.videos) {
			this.childViews.videos = [];
		}
		this.$('.js-modal-gallery-video').each((index, videoElement) => {
			this.childViews.videos.push(
				new VideoView({
					el: videoElement
				})
			);
		});
		this._resizeVideos();
	},
	_resizeVideos() {
		const height = $(window).height() / 2;
		const width = window.BCOM.device.isMobile ? $(window).width() - 10 : $(window).width() / 2;
		this.$modal.find('.js-media-gallery-modal-carousel video').css('max-height', height);
		this.$modal.find('div.video').css({
			height: 'auto',
			width
		});
	},
	_hoverGalleryThumbnail(event) {
		const $thumb = $(event.currentTarget);
		$thumb
			.addClass('active')
			.siblings()
			.removeClass('active');
		this.currentIndex = $thumb.data('iterator');
		this.setGalleryImage();
	},

	_selectGalleryThumbnail(event) {
		this._pauseVideos();
		this.currentIndex = $(event.currentTarget).data('iterator');
		this.setGalleryImage();

		this._updateSelected();

		if (window.BCOM.device.isDesktop) {
			this.launchMediaGalleryModal.call(this);
		}
	},

	_selectFinishThumbnail(image) {
		const currentFinish = window.dataLayer.finishes.find((finish) => finish.uniqueId === image.uniqueId);

		this.currentIndex = currentFinish ? currentFinish.iterator : -1;
		this.setGalleryImage();
	},

	_selectCarouselImage(event) {
		if (this.slideAnimating) {
			return;
		}
		this._pauseVideos();
		this.currentIndex = $(event.currentTarget).data('iterator');
		this.$galleryThumbNail.find('.js-gallery-big-thumb').removeClass('active');
		$(event.currentTarget).addClass('active');
		this._updateSelected();
		if (this.$slider && this.$slider.length) {
			this.$slider.slick('slickGoTo', this.currentIndex);
		}
		this._resetZoom();
	},

	setGalleryImage() {
		const currentIndex = this.currentIndex === -1 ? 0 : this.currentIndex;
		if (window.BCOM.device.isDesktop) {
			if (this.gallery[this.currentIndex]) {
				const $galleryImage = this.$('.js-gallery-image img'),
					$videoButton = this.$('.js-modal-play-video-button');
				if (this.gallery[currentIndex].isVideo) {
					$galleryImage.attr('src', this.gallery[currentIndex].video.thumbUrl);
					$videoButton.removeClass('hidden');
				} else {
					$galleryImage.attr('src', this.gallery[currentIndex].IMAGEPATHS[450]);
					$videoButton.addClass('hidden');
				}
			}
		} else {
			this.$slider.slick('slickGoTo', this.currentIndex);
		}
	},
	_resizeGallery() {
		const height = $(window).height() - 153;
		this.$modal.find('.js-media-gallery-modal-carousel img').css('max-height', height);
		this.$modal.find('.js-image').css({
			height,
			width: $(window).width()
		});
		this.$modal.find('.js-image .slick-track').height(height);
		if (this.childViews.videos) {
			this._resizeVideos();
		}
	},
	_initZoom() {
		if (!window.BCOM.device.isMobile) {
			return;
		}

		this.$gallery = this.$modal.find('.js-carousel-media-gallery');

		$('.js-modal-media-gallery')
			.addSwipeEvents()
			.on('touch', () => {
				if (this.$('.js-zoom-tooltip').is(':visible')) {
					this.$('.js-zoom-tooltip').hide();
				}
			});

		this.$gallery
			.find('img')
			.addSwipeEvents()
			.on('doubletap', (evt, touch) => {
				if (!evt.target) {
					return;
				}
				if (!this.isZoomedIn) {
					$(evt.target).panzoom('zoom', {
						focal: touch.touch,
						scale: 5,
						animate: true
					});
					this.isZoomedIn = true;
				} else {
					$(evt.target).panzoom('reset', true);
				}
			})
			.on('panzoomreset', () => {
				this.isZoomedIn = false;
			})
			.on('panzoomzoom', (e, panzoom, scale) => {
				if (scale === 1) {
					$(e.target).panzoom('reset', true);
					return;
				}
				this.isZoomedIn = true;
			})
			.on('swipeleft', () => {
				if (!this.isZoomedIn) {
					this.$slider.slick('slickNext');
				}
			})
			.on('swiperight', () => {
				if (!this.isZoomedIn) {
					this.$slider.slick('slickPrev');
				}
			});
		this.$gallery.find('img').panzoom({
			increment: 0.5,
			duration: 200,
			disablePan: false,
			minScale: 1,
			maxScale: 5,
			contain: 'invert',
			$reset: $('.reset-panzoom')
		});
	},
	_resetZoom() {
		if (!window.BCOM.device.isMobile || !this.$gallery || !this.$gallery.length) {
			return;
		}

		this.$gallery.panzoom('resetPan');
		this.$gallery.panzoom('resetZoom');
	},
	_updateSelected() {
		if (!window.BCOM.device.isMobile) {
			return;
		}

		$('.js-gallery-thumbnail, .js-gallery-big-thumb').removeClass('selected');
		$(
			`.js-gallery-thumbnail[data-iterator="${this.currentIndex}"], .js-gallery-big-thumb[data-iterator="${this.currentIndex}"]`
		).addClass('selected');
	},
	_modalClosed() {
		this.$('.js-modal-media-gallery').removeClass('single-finish');
		if (!window.BCOM.device.isDesktop) {
			this.$slider = this.$el.find('.js-img-swipe');
		}
		if (this.childViews.videos) {
			this.childViews.videos.forEach((videoView) => videoView.stopPlayer());
		}
	},
	_onModalHide() {
		if (this.wasAffixed) {
			if ($(window).scrollTop() > 10) {
				this.$mainMediaGallery.addClass('affix');
			}
			this.wasAffixed = false;
		}
	}
});
